module.exports = __webpack_public_path__ + "static/media/IMG_1364.80b675d1.JPG";